import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.powder,
  h1Color: colors.metal,
  h2Color: colors.metal,
  paraColor: colors.metal,
  anchorColor: colors.dirtBrown
};
export default richText;